import classes from "./ClassResult.module.css";
import styles from "./styles.module.css";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import React from "react";
import {checkUnansweredNew, questionHasCorrectness} from "../../utils/helpers";
import {
    ASCII_CODE_A, OTHER_TEXT,
    QUESTION_TYPES,
    RESPONSIVE_SIDE_BAR_POINT,
    YOUR_RESPONSE_TEXT,
} from "../../utils/constants";
import ImageViewer from "./ImageViewer";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { ReactComponent as CORRECT_ICON } from "../../images/grade-question-correct-icon.svg";
import { ReactComponent as INCORRECT_ICON } from "../../images/grade-question-incorrect-icon.svg";
import { ReactComponent as ARROW } from "../../images/arrow_right.svg";
import {LatexInline} from "../../components/Tiptap/latexParser";
import {isGeneralSA} from "../../utils/questionUtils";

export default function RenderYourResponse({
                                              questionData,
                                              showAnswerOnViewer,
                                              curUserResponses=[],
                                              dataLoading
}) {
    let {width: windowWidth} = useWindowDimensions();
    const {correctAnswers, serialNo, questionType, optionsImageMap={}, optionsMap} = questionData;
    let queResponse = !!curUserResponses
        ? curUserResponses.find(q => q.serialNo === serialNo)
        : null;
    queResponse = !!queResponse ? queResponse : {};
    let {selectedOption} = queResponse;
    let shouldShowCorrect = questionHasCorrectness(questionData) && !!showAnswerOnViewer;

    if (!!dataLoading) {
        return (
            <>
                <span className={classes.label}>
                    <span>{YOUR_RESPONSE_TEXT}</span>
                </span>

                {!!dataLoading &&
                    <div className={styles.optionContainer}>
                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                            <Skeleton borderRadius={4} height={40} width={"min(80vw, 500px)"}
                                      style={{position: "relative", borderRadius: "10px"}}/>
                        </SkeletonTheme>
                    </div>
                }

            </>
        );
    }

    if (checkUnansweredNew(questionType, selectedOption)) {
        return (
            <>
                <span className={classes.label}>{YOUR_RESPONSE_TEXT}</span>
                <div className={classes.yourResponseContainer}>-</div>
            </>
        );
    }


    return (
        <>
            <span className={classes.label}>{YOUR_RESPONSE_TEXT}</span>
            {questionType === QUESTION_TYPES.MCSS.name && !Array.isArray(selectedOption) &&
                <div
                    className={`${classes.yourResponseContainer}
                        ${!!shouldShowCorrect && correctAnswers.includes(selectedOption) ? classes.correct : ""}
                        ${!!shouldShowCorrect && !correctAnswers.includes(selectedOption) ? classes.incorrect : ""}
                        `}
                >
                    {!!shouldShowCorrect && correctAnswers.includes(selectedOption) &&
                        <span className={`${classes.indicator} ${classes.correct}`}>
                                <CORRECT_ICON/>
                            </span>
                    }

                    {!!shouldShowCorrect && !correctAnswers.includes(selectedOption) &&
                        <span className={`${classes.indicator} ${classes.incorrect}`}>
                                <INCORRECT_ICON/>
                            </span>
                    }

                    <span className={classes.optionIndex}>
                        {selectedOption.toString().toUpperCase()}
                    </span>
                    {!!optionsImageMap[selectedOption]?.imageURL &&
                        <ImageViewer
                            size={38}
                            imageURL={optionsImageMap[selectedOption]?.imageURL}
                        />
                    }
                    <LatexInline>{optionsMap[selectedOption]}</LatexInline>
                </div>
            }

            {questionType === QUESTION_TYPES.MCSS.name && Array.isArray(selectedOption) &&
                (selectedOption.map((option, i) =>
                    <div
                        key={i}
                        className={`${classes.yourResponseContainer} 
                            ${!!shouldShowCorrect && correctAnswers.includes(option) ? classes.correct : ""}
                            ${!!shouldShowCorrect && !correctAnswers.includes(option) ? classes.incorrect : ""}
                            `}
                    >
                        {!!shouldShowCorrect && correctAnswers.includes(option) &&
                            <span className={`${classes.indicator} ${classes.correct}`}>
                                    <CORRECT_ICON/>
                                </span>
                        }

                        {!!shouldShowCorrect && !correctAnswers.includes(option) &&
                            <span className={`${classes.indicator} ${classes.incorrect}`}>
                                    <INCORRECT_ICON/>
                                </span>
                        }
                        <span className={classes.optionIndex}>
                                {option.toString().toUpperCase()}
                            </span>
                        {!!optionsImageMap[option]?.imageURL &&
                            <ImageViewer
                                size={38}
                                imageURL={optionsImageMap[option]?.imageURL}
                            />
                        }
                        <LatexInline>{optionsMap[option]}</LatexInline>
                    </div>
                ))}
            {questionType === QUESTION_TYPES.TF.name &&
                <div
                    className={`${classes.yourResponseContainer}
                        ${!!shouldShowCorrect && correctAnswers === selectedOption ? classes.correct : ""}
                        ${!!shouldShowCorrect && correctAnswers !== selectedOption ? classes.incorrect : ""}
                        `}
                >
                    {!!shouldShowCorrect && correctAnswers === selectedOption &&
                        <span className={`${classes.indicator} ${classes.correct}`}>
                                <CORRECT_ICON/>
                            </span>
                    }

                    {!!shouldShowCorrect && correctAnswers !== selectedOption &&
                        <span className={`${classes.indicator} ${classes.incorrect}`}>
                                <INCORRECT_ICON/>
                            </span>
                    }
                    <span aria-label={selectedOption} >
                        {selectedOption}
                    </span>
                </div>
            }

            {questionType === QUESTION_TYPES.CI.name &&
                <div
                    className={`${classes.yourResponseContainer}
                        ${!!shouldShowCorrect && correctAnswers.includes(parseInt(selectedOption.selected)) ? classes.correct : ""}
                        ${!!shouldShowCorrect && !correctAnswers.includes(parseInt(selectedOption.selected)) ? classes.incorrect : ""}
                        `}
                >
                    {!!shouldShowCorrect && correctAnswers.includes(parseInt(selectedOption.selected)) &&
                        <span className={`${classes.indicator} ${classes.correct}`}>
                                <CORRECT_ICON/>
                            </span>
                    }

                    {!!shouldShowCorrect && !correctAnswers.includes(parseInt(selectedOption.selected)) &&
                        <span className={`${classes.indicator} ${classes.incorrect}`}>
                                <INCORRECT_ICON/>
                            </span>
                    }
                    {!isNaN(parseInt(selectedOption.selected)) &&
                        <span className={classes.optionIndex}>
                                {String.fromCharCode(parseInt(selectedOption.selected) + ASCII_CODE_A)}
                            </span>
                    }

                    <LatexInline>
                        {optionsMap[selectedOption.selected]?.text ? optionsMap[selectedOption.selected]?.text : OTHER_TEXT}
                    </LatexInline>
                </div>
            }

            {isGeneralSA(questionType) &&
                <div className={classes.yourResponseContainer}>
                    {selectedOption["0"]}
                </div>
            }

            {questionType === QUESTION_TYPES.OE.name &&
                <div className={classes.yourResponseContainer}>
                    {selectedOption["0"]}
                </div>
            }

            {questionType === QUESTION_TYPES.FITB.name &&
                (Object.keys(selectedOption).map((blankName, i) =>
                    <div
                        key={i}
                        className={`${classes.yourResponseContainer}
                            ${!!shouldShowCorrect && correctAnswers[blankName].includes(selectedOption[blankName]) ? classes.correct : ""}
                            ${!!shouldShowCorrect && !correctAnswers[blankName].includes(selectedOption[blankName]) ? classes.incorrect : ""}
                            `}
                    >
                        {!!shouldShowCorrect && correctAnswers[blankName].includes(selectedOption[blankName]) &&
                            <span className={`${classes.indicator} ${classes.correct}`}>
                                <CORRECT_ICON/>
                            </span>
                        }

                        {!!shouldShowCorrect && !correctAnswers[blankName].includes(selectedOption[blankName]) &&
                            <span className={`${classes.indicator} ${classes.incorrect}`}>
                                <INCORRECT_ICON/>
                            </span>
                        }
                        <span>
                            {selectedOption[blankName] ? selectedOption[blankName] : "-"}
                        </span>
                    </div>
                ))
            }

            {questionType === QUESTION_TYPES.MH.name &&
                <div style={{ display: "flex", width: "100%", flexDirection: "column", gap: 10}}>
                    {correctAnswers.map((element, index) => {
                        if (element.length === 1) {
                            return <></>;
                        }

                        let ans = selectedOption[`${index}`];
                        let isCorrect = null;
                        if (shouldShowCorrect) {
                            isCorrect = ans === element[1];
                        }

                        return (
                            <div
                                key={index}
                                className={
                                    windowWidth > RESPONSIVE_SIDE_BAR_POINT
                                        ? classes.MHGridContainer
                                        : classes.MHVerticalContainer
                                }
                            >
                                {!(windowWidth > RESPONSIVE_SIDE_BAR_POINT) && index !== 0 &&
                                    <div className={classes.MHDivider}/>
                                }

                                <div className={classes.MHPremise}>
                                    <LatexInline>{element[0]}</LatexInline>
                                </div>
                                {windowWidth > RESPONSIVE_SIDE_BAR_POINT && <ARROW/>}
                                <div
                                    style={{minHeight: 47}}
                                    className={`${classes.yourResponseContainer}
                                        ${isCorrect === true ? classes.correct : ""}
                                        ${isCorrect === false ? classes.incorrect : ""}
                                        `}
                                >
                                    {isCorrect === true  &&
                                        <span className={`${classes.indicator} ${classes.correct}`}>
                                                <CORRECT_ICON/>
                                            </span>
                                    }

                                    {isCorrect === false &&
                                        <span className={`${classes.indicator} ${classes.incorrect}`}>
                                                <INCORRECT_ICON/>
                                            </span>
                                    }
                                    <LatexInline>{ans ? ans : "-"}</LatexInline>
                                </div>
                            </div>
                        );
                    })}
                </div>
            }

            {questionType === QUESTION_TYPES.WC.name &&
                <div className={classes.yourResponseContainer}>
                    <div>
                        {Object.values(selectedOption).map((value , index) =>
                            <div key={index}>- {value}</div>
                        )}
                    </div>
                </div>
            }

            {questionType === QUESTION_TYPES.RK.name && (selectedOption.map((value, index) =>
                <div key={index} className={classes.yourResponseContainer}>
                    <span className={classes.optionIndex}>
                        {index + 1}
                    </span>
                    <LatexInline>{value}</LatexInline>
                </div>
            ))}
        </>
    );
}